import { render, staticRenderFns } from "./ItemStorageEdit.vue?vue&type=template&id=5d6f1e26&scoped=true"
import script from "./ItemStorageEdit.vue?vue&type=script&lang=js"
export * from "./ItemStorageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6f1e26",
  null
  
)

export default component.exports